<div class="sp-order-details-qinetic__grid sp-min-height__full">
  <app-order-details-qinetic-position
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-qinetic-position>

  <app-order-details-qinetic-info
    *ngIf="!is_read_running"
    class="sp-order-details-qinetic__info"
    [order]="order"></app-order-details-qinetic-info>

  <app-order-details-qinetic-docs
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-qinetic-docs>

  <app-order-details-qinetic-refund
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-qinetic-refund>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-qinetic__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-qinetic__info sp-order-details-qinetic__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-qinetic__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-qinetic__loading"></app-loading>
</div>
